import { useEventsContext } from '../../../context/events/EventsContext';
import { useDeleteClipMutation } from '../operation.generated';
import { EventName } from '../../../services/EventTrackingService';

const useOptimisticDeleteClip = (
  options: Parameters<typeof useDeleteClipMutation>[0] = {}
) => {
  const [eventTracking] = useEventsContext();
  return useDeleteClipMutation({
    optimisticResponse: ({ inputs: { clipId } }) => ({
      deleteClip: {
        __typename: 'DeleteClipMutationResponse',
        clip: {
          id: clipId,
          isDeleted: true,
          __typename: 'Clip',
        },
        wasReCredited: false,
        success: true,
        code: 'graphql_mutation_success',
        message: 'Deleted clip successfully',
      },
    }),
    onCompleted: data => {
      if (data.deleteClip.success && data.deleteClip.clip) {
        const { clip, wasReCredited } = data.deleteClip;
        eventTracking.track({
          type: EventName.ClipDeleted,
          data: {
            clipId: clip.id,
            wasRecredited: Boolean(wasReCredited),
          },
        });
      }
    },
    ...options,
  });
};

export default useOptimisticDeleteClip;
